import React from 'react';
import { AlertCircle } from 'lucide-react';

/** Soft working-time / rest reminder — same modal pattern as unlock/delete on the schedule. */
export function RestRuleWarningsModal({
  warnings,
  onClose,
}: {
  warnings: string[];
  onClose: () => void;
}) {
  if (!warnings.length) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="rest-rule-warning-title"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 p-6 border-b">
          <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
            <AlertCircle className="w-5 h-5 text-amber-600" />
          </div>
          <h2 id="rest-rule-warning-title" className="text-xl font-semibold text-gray-800">
            Working time / rest reminder
          </h2>
        </div>

        <div className="p-6">
          <p className="text-gray-700 mb-4">
            The shift was saved. Review the reminder below — this does not block the roster.
          </p>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 space-y-3">
            {warnings.map((w, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-5 h-5 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-white text-xs font-bold">!</span>
                </div>
                <p className="text-amber-900 text-sm whitespace-pre-wrap">{w}</p>
              </div>
            ))}
          </div>

          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-amber-600 text-white rounded hover:bg-amber-700"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
